/**
 * package-contents.js
 * ------------------------------------------------------------------
 * Rendert en actualiseert de "Inhoud van de verpakking"-sectie.
 * Werkt met vrijwel elk Online Store 2.0-thema (Dawn en afgeleiden),
 * omdat de huidige variant op drie onafhankelijke manieren wordt
 * gevolgd:
 *   1. Direct uitlezen van de zichtbare variant-selectors (select /
 *      radio-inputs) op basis van de optienaam ("Aantal camera's",
 *      "Opslag").
 *   2. Via het verborgen <input name="id"> veld in het bestelformulier,
 *      gekoppeld aan de variantenlijst van het product.
 *   3. Als vangnet: korte polling, voor thema's die de waarde van dat
 *      veld met JavaScript zetten zonder een 'change'-event te vuren.
 * ------------------------------------------------------------------
 */
(function () {
  "use strict";

  // Kleine, gedeelde icoon-bibliotheek (lijnstijl, zelfde stroke-dikte als
  // het hoofdicoon). "icon"-sleutels komen overeen met de sleutels die in
  // de Liquid-bestanden vóór elk item staan (bv. "camera::PoE Beveiligingscamera").
  // Onbekende/lege sleutels vallen terug op het doosje-icoon (default).
  var ICON_PATHS = {
    default:
      '<path d="M3 7l9-4 9 4-9 4-9-4z"/><path d="M3 7v10l9 4 9-4V7"/><path d="M12 11v10"/>',
    nvr:
      '<rect x="3" y="7" width="18" height="10" rx="1.5"/><line x1="6" y1="11" x2="10" y2="11"/><line x1="6" y1="14" x2="10" y2="14"/><circle cx="17" cy="12.5" r="1.1" fill="currentColor" stroke="none"/>',
    mouse: '<rect x="8" y="3" width="8" height="14" rx="4"/><line x1="12" y1="3" x2="12" y2="9"/>',
    hdmi: '<path d="M6 9h12l-1.5 6h-9L6 9z"/><line x1="9" y1="15" x2="9" y2="18"/><line x1="15" y1="15" x2="15" y2="18"/>',
    cable:
      '<rect x="3" y="9" width="4" height="6" rx="1"/><rect x="17" y="9" width="4" height="6" rx="1"/><line x1="7" y1="12" x2="17" y2="12"/>',
    power:
      '<rect x="8" y="3" width="8" height="10" rx="1.5"/><line x1="10" y1="13" x2="10" y2="16"/><line x1="14" y1="13" x2="14" y2="16"/><line x1="12" y1="16" x2="12" y2="21"/>',
    manual:
      '<path d="M5 4h9a3 3 0 0 1 3 3v13H8a3 3 0 0 1-3-3V4z"/><line x1="8" y1="8" x2="14" y2="8"/><line x1="8" y1="12" x2="14" y2="12"/>',
    hdd:
      '<rect x="3" y="5" width="18" height="14" rx="2"/><circle cx="12" cy="12" r="3.2"/><circle cx="12" cy="12" r="0.6" fill="currentColor" stroke="none"/>',
    camera:
      '<path d="M4 8a2 2 0 0 1 2-2h2l1.5-2h5L16 6h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V8z"/><circle cx="12" cy="13" r="3.3"/>',
    screw:
      '<circle cx="8" cy="8" r="3.3"/><line x1="6.4" y1="6.4" x2="9.6" y2="9.6"/><line x1="9.6" y1="6.4" x2="6.4" y2="9.6"/><line x1="10.5" y1="10.5" x2="18" y2="18"/>',
    cap: '<path d="M12 3c4 2 6 5 6 9a6 6 0 0 1-12 0c0-4 2-7 6-9z"/><path d="M9.5 13.5c.8.8 1.6 1.2 2.5 1.2s1.7-.4 2.5-1.2"/>',
    wifi:
      '<path d="M5 9a11 11 0 0 1 14 0"/><path d="M8 12.5a6.5 6.5 0 0 1 8 0"/><circle cx="12" cy="19" r="0.9" fill="currentColor" stroke="none"/>'
  };

  function renderIcon(key) {
    var inner = ICON_PATHS[key] || ICON_PATHS.default;
    return (
      '<svg class="pc-item-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      inner +
      "</svg>"
    );
  }

  function initPackageContents(root) {
    if (!root || root.dataset.pcInitialised === "true") return;
    root.dataset.pcInitialised = "true";

    var grid = root.querySelector("[data-package-contents-grid]");
    var blocksEl = root.querySelector("[data-package-contents-blocks]");
    var variantsEl = root.querySelector("[data-package-contents-variants]");
    if (!grid || !blocksEl || !variantsEl) return;

    var blocks = safeParse(blocksEl.textContent, []);
    var variants = safeParse(variantsEl.textContent, []);

    var cameraOptionName = root.dataset.cameraOptionName || "";
    var storageOptionName = root.dataset.storageOptionName || "";
    var cameraOptionIndex = parseInt(root.dataset.cameraOptionIndex, 10);
    var storageOptionIndex = parseInt(root.dataset.storageOptionIndex, 10);
    var storageFallback = root.dataset.storageFallback || "HDD";

    // Zoek het bijbehorende bestelformulier (product-add-to-cart form).
    var form = root.closest("form");
    if (!form) {
      form =
        document.querySelector('form[action*="/cart/add"]') ||
        document.querySelector("form[data-type='add-to-cart-form']");
    }
    var variantIdInput = form ? form.querySelector('input[name="id"]') : null;
    if (!variantIdInput) {
      variantIdInput = document.querySelector('input[name="id"]');
    }

    var lastVariantId = variantIdInput ? variantIdInput.value : null;
    var lastRenderedKey = null;

    function safeParse(str, fallback) {
      try {
        return JSON.parse(str);
      } catch (e) {
        return fallback;
      }
    }

    function extractCount(rawValue) {
      if (!rawValue) return 1;
      var match = String(rawValue).match(/\d+/);
      return match ? parseInt(match[0], 10) : 1;
    }

    // Methode 1: lees de waarde rechtstreeks uit de zichtbare
    // variant-selector op basis van de optienaam (naam-attribuut of
    // een <legend>/label in de buurt).
    function readVisibleOptionValue(optionName) {
      if (!optionName) return null;
      var scope = form || document;

      var select = scope.querySelector('select[name="' + cssEscape(optionName) + '"]');
      if (select && select.value) return select.value;

      var checkedRadio = scope.querySelector(
        'input[type="radio"][name="' + cssEscape(optionName) + '"]:checked'
      );
      if (checkedRadio && checkedRadio.value) return checkedRadio.value;

      // Fallback: sommige thema's prefixen het name-attribuut, bv.
      // "options[Aantal camera's]". Doorzoek daarom ook op inhoud.
      var fieldsets = scope.querySelectorAll("fieldset, .product-form__input");
      for (var i = 0; i < fieldsets.length; i++) {
        var labelNode = fieldsets[i].querySelector("legend, label");
        if (
          labelNode &&
          labelNode.textContent
            .trim()
            .toLowerCase()
            .indexOf(optionName.trim().toLowerCase()) === 0
        ) {
          var sel = fieldsets[i].querySelector("select");
          if (sel && sel.value) return sel.value;
          var radio = fieldsets[i].querySelector('input[type="radio"]:checked');
          if (radio && radio.value) return radio.value;
        }
      }
      return null;
    }

    function cssEscape(value) {
      if (window.CSS && window.CSS.escape) return window.CSS.escape(value);
      return value.replace(/["\\]/g, "\\$&");
    }

    // Methode 2: haal de optiewaarde op via de huidige variant-id.
    function readOptionValueFromVariant(optionIndex) {
      if (optionIndex < 0 || !variantIdInput) return null;
      var currentId = variantIdInput.value;
      var variant = null;
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === String(currentId)) {
          variant = variants[i];
          break;
        }
      }
      if (!variant || !variant.options) return null;
      return variant.options[optionIndex] || null;
    }

    function getCameraCount() {
      var value = readVisibleOptionValue(cameraOptionName);
      if (value == null) value = readOptionValueFromVariant(cameraOptionIndex);
      return extractCount(value);
    }

    function getStorageLabel() {
      var value = readVisibleOptionValue(storageOptionName);
      if (value == null) value = readOptionValueFromVariant(storageOptionIndex);
      return value || storageFallback;
    }

    function render() {
      var cameraCount = getCameraCount();
      var storageLabel = getStorageLabel();
      var key = cameraCount + "|" + storageLabel;
      if (key === lastRenderedKey) return;
      lastRenderedKey = key;

      var items = [];

      blocks.forEach(function (block) {
        if (block.type === "fixed_item") {
          items.push({ qty: "1x", text: block.text, icon: block.icon });
        } else if (block.type === "hdd_item") {
          items.push({
            qty: "1x",
            text: storageLabel + " " + block.text,
            icon: block.icon
          });
        } else if (block.type === "per_camera_item") {
          items.push({ qty: cameraCount + "x", text: block.text, icon: block.icon });
        }
      });

      var html = "";
      items.forEach(function (item) {
        html +=
          '<li><span class="pc-item-left">' +
          '<span class="pc-qty">' +
          escapeHtml(item.qty) +
          "</span>" +
          '<span class="pc-item-text">' +
          escapeHtml(item.text) +
          "</span></span>" +
          renderIcon(item.icon) +
          "</li>";
      });
      grid.innerHTML = html;
    }

    function escapeHtml(str) {
      return String(str == null ? "" : str).replace(/[&<>"']/g, function (c) {
        return (
          { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]
        );
      });
    }

    // --- Event-koppeling: dekt vrijwel elk thema ---

    // 1) Directe interactie met select/radio binnen het formulier.
    var scopeForEvents = form || document;
    scopeForEvents.addEventListener("change", render);
    scopeForEvents.addEventListener("input", render);

    // 2) MutationObserver op het verborgen variant-id veld, voor
    //    thema's die de waarde via setAttribute wijzigen.
    if (variantIdInput && window.MutationObserver) {
      var observer = new MutationObserver(render);
      observer.observe(variantIdInput, { attributes: true, attributeFilter: ["value"] });
    }

    // 3) Vangnet: korte polling voor thema's die de waarde via de
    //    JS-property zetten zonder event of attribuut-wijziging.
    setInterval(function () {
      if (variantIdInput && variantIdInput.value !== lastVariantId) {
        lastVariantId = variantIdInput.value;
        render();
      }
    }, 400);

    // 4) Reageer ook op Shopify's eigen "variant:change"-achtige
    //    custom events, mocht het thema die uitzenden.
    document.addEventListener("variant:change", render);
    document.addEventListener("on:variant:change", render);

    // Eerste render.
    render();
  }

  function init() {
    document.querySelectorAll("[data-package-contents]").forEach(initPackageContents);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  // Shopify theme-editor: her-initialiseer bij het (opnieuw) laden van de sectie.
  document.addEventListener("shopify:section:load", function (event) {
    var el = event.target.querySelector
      ? event.target.querySelector("[data-package-contents]")
      : null;
    if (el) {
      el.dataset.pcInitialised = "false";
      initPackageContents(el);
    }
  });
})();